"use client";

import type { CSSProperties, ReactElement, ReactNode } from "react";
import { Cmarkdownvisual, CmarkdownvisualType } from "../Cmarkdownvisual";
import { CONTAINER_PADDING } from "./timeline-constants";

const TIMELINE_METRIC_UNIT = "EVENTS";

export interface TimelineVisualFrameProps {
  children: ReactNode;
  className?: string;
  compactPreview: ReactElement | null;
  containerHeight: number;
  controls: ReactElement;
  style?: CSSProperties;
  totalEvents: number;
}

export function TimelineVisualFrame({
  children,
  className,
  compactPreview,
  containerHeight,
  controls,
  style,
  totalEvents,
}: TimelineVisualFrameProps): ReactElement {
  return (
    <Cmarkdownvisual
      dataElScope="Cmarkdowntimeline/TimelineVisualFrame"
      type={CmarkdownvisualType.Timeline}
      controls={controls}
      modalControls={controls}
      contentStyle={{
        minHeight: containerHeight,
        padding: `${CONTAINER_PADDING}px 0`,
        position: "relative",
        flex: 1,
      }}
      className={className}
      style={style}
      compactPreview={compactPreview}
      metric={{ value: totalEvents, unit: TIMELINE_METRIC_UNIT }}
    >
      {children}
    </Cmarkdownvisual>
  );
}
